import { pages } from '@/entities/current-page';

const state = {
  activePage: pages.HOME,
};

const mutations = {
  SET_ACTIVE_PAGE(state, page) {
    state.activePage = page;
  }
};

const actions = {
  changeActivePage({ commit }, page) {
    commit('SET_ACTIVE_PAGE', page);
  },
};

const getters = {
  getActivePage: (state) => state.activePage,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
